import { FC } from 'react'
import { DisplayablePurchasePrice } from '@lifedot/utils'

interface Props {
  price: DisplayablePurchasePrice | undefined | null
}

export const Price: FC<Props> = ({ price }) => {
  if (!price || !price.priceNumber) return null

  return (
    <span>
      {price.priceNumber}
      {price.priceUnit}
      {price.priceSupplement}
    </span>
  )
}
